import React, { useState } from "react";

import { Card, Typography, Pagination, Table, Popconfirm, message } from "antd";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { useParams } from "react-router-dom";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";
import { DeleteTwoTone } from "@ant-design/icons";
import BulkClientsAdd from "../../../../components/AdminComponents/Modals/BulkClientsAdd";
import { useSelector } from "react-redux";
import axiosInstance from "../../../../api/Axios";

const { Title } = Typography;
const CourseClients = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Client organization has been Deleted .",
      duration: 5,
    });

    setLoadAgain(true);
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Client organization Delete Failed",
      duration: 5,
    });
  };

  const handleDelete = async (record) => {
    // const payload = {
    //   // id: record?.id,
    //   course_id: Number(id),
    //   organization_id: userInfo?.data?.organization?.id,
    // };
    // console.log(payload);
    try {
      await axiosInstance.delete(
        `/learn/courseorganizationdelete/${record.id}/`,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };
  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `/courseorganizationlist/?course_id=${id}`,
    loadAgain: loadAgain,
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const columns = [
    {
      title: "Client ID",
      dataIndex: "client_id",
      key: "client_id",
      width: 140,
    },
    {
      title: "Client Name",
      dataIndex: "client_name",
      key: "client_name",
      width: 250,
    },

    {
      title: "Assigned Date",
      dataIndex: "assigned_at",
      key: "assigned_at",
      width: 150,
      render: GetFormattedDateTime,
    },

    ...(props?.ImpersonateAccess
      ? [
          {
            title: "Actions",
            dataIndex: "id",
            key: "id",
            align: "center",
            width: 150,
            render: (text, record) =>
              record?.is_deleted === true ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Popconfirm
                    title={"Remove client?"}
                    description=" "
                    onConfirm={() => handleDelete(record)}
                    // onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                    placement="leftTop"
                  >
                    <DeleteTwoTone
                      key="delete"
                      style={{
                        cursor: "pointer",
                        fontSize: "1.6rem",
                        marginLeft: "0.9rem",
                      }}
                      title="delete"
                      twoToneColor="#eb2f96"
                    />
                  </Popconfirm>
                </div>
              ) : null,
          },
        ]
      : []),
  ];
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Clients Summary
      </Title>
      <CommonTopDetails
        title={`Course Clients`}
        titleSuffix={`${itemsLength || 0} client(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => setIsBulkModalOpen((prev) => !prev),
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 500,
        }}
        bordered
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <BulkClientsAdd
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        course_id={id}
        LoadAPI={LoadAPI}
        callMain={props.LoadUser}
      />
    </Card>
  );
};

export default CourseClients;
